(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lpk-lead"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', function (e) {
  var form = e.target.closest('.lpk-lead__form');
  if (!form) return;
  e.preventDefault();
  var msg = form.querySelector('.lpk-lead__msg');
  var email = form.querySelector('input[name="email"]');
  var consent = form.querySelector('input[name="consent"]');
  var show = function (text, ok) { msg.hidden = false; msg.textContent = text; msg.className = 'lpk-lead__msg' + (ok ? ' is-ok' : ' is-err'); };
  if (!email.value || email.value.indexOf('@') < 1) { show('Bitte gib eine gültige E-Mail-Adresse ein.', false); return; }
  if (consent && !consent.checked) { show('Bitte bestätige die Einwilligung.', false); return; }
  var hutk = (document.cookie.match(/hubspotutk=([^;]+)/) || [])[1];
  var body = {
    fields: [
      { name: 'email', value: email.value.trim() },
      { name: 'livom_lp', value: form.dataset.lp || '' }
    ],
    context: { pageUri: window.location.href, pageName: document.title }
  };
  if (hutk) body.context.hutk = hutk;
  if (form.dataset.consentId) {
    body.legalConsentOptions = { consent: { consentToProcess: true, text: form.dataset.consentText || '',
      communications: [{ value: true, subscriptionTypeId: parseInt(form.dataset.consentId, 10), text: form.dataset.consentText || '' }] } };
  }
  var btn = form.querySelector('button[type="submit"]');
  btn.disabled = true;
  fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + form.dataset.portal + '/' + form.dataset.form, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
  }).then(function (r) {
    if (!r.ok) throw new Error('hubspot ' + r.status);
    form.querySelector('.lpk-lead__row').hidden = true;
    var c = form.querySelector('.lpk-lead__consent'); if (c) c.hidden = true;
    var l = form.querySelector('.lpk-lead__label'); if (l) l.hidden = true;
    show(form.dataset.thanks || 'Danke! Schau in dein Postfach – dein Gutschein ist unterwegs.', true);
    if (window.dataLayer) window.dataLayer.push({ event: 'lp_lead_signup', lp: form.dataset.lp });
  }).catch(function () {
    btn.disabled = false;
    show('Das hat leider nicht geklappt. Bitte versuch es später noch einmal.', false);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpk-sticky"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(bar) {
    if (bar.dataset.lpkReady) return;
    bar.dataset.lpkReady = '1';

    // Die LP-Sections animieren mit transform — das erzeugt einen eigenen
    // Containing Block, in dem position:fixed nicht mehr am Viewport klebt.
    // Deshalb hängt sich die Bar direkt an <body>.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);

    // Countdown auf das Sale-Ende; läuft er ab, greift der Fallback-Text.
    var timer = bar.querySelector('[data-lpk-timer]');
    var badge = bar.querySelector('[data-lpk-badge]');
    var deadline = null;
    if (bar.dataset.countdown) {
      var parsed = new Date(bar.dataset.countdown.replace(' ', 'T'));
      if (!isNaN(parsed.getTime())) deadline = parsed;
    }

    function tickTimer() {
      if (!deadline || !timer) return;
      var left = deadline.getTime() - Date.now();
      if (left <= 0) {
        timer.hidden = true;
        if (badge) badge.hidden = false;
        var head = bar.querySelector('[data-lpk-head]');
        var sub = bar.querySelector('[data-lpk-sub]');
        if (head && bar.dataset.headExpired) head.textContent = bar.dataset.headExpired;
        if (sub && bar.dataset.subExpired) sub.textContent = bar.dataset.subExpired;
        deadline = null;
        return;
      }
      var mins = Math.floor(left / 60000);
      var hours = Math.floor(mins / 60);
      var days = Math.floor(hours / 24);
      var num = bar.querySelector('[data-lpk-timer-num]');
      var unit = bar.querySelector('[data-lpk-timer-unit]');
      if (days >= 1) {
        num.textContent = days;
        unit.textContent = days === 1 ? 'Tag' : 'Tage';
      } else {
        num.textContent = hours + ':' + ('0' + (mins % 60)).slice(-2);
        unit.textContent = 'Stunden';
      }
      timer.hidden = false;
      if (badge) badge.hidden = true;
    }

    tickTimer();
    if (deadline) window.setInterval(tickTimer, 30000);

    var key = 'lpkSticky:' + (bar.dataset.lp || 'lp');
    try { if (sessionStorage.getItem(key) === 'closed') { bar.remove(); return; } } catch (e) {}

    bar.hidden = false;
    var offset = parseInt(bar.dataset.offset, 10);
    if (isNaN(offset) || offset < 0) offset = 600;

    var suppressed = false;
    var nearSel = (bar.dataset.hideNear || '').trim();
    if (nearSel && 'IntersectionObserver' in window) {
      var targets = document.querySelectorAll(nearSel);
      if (targets.length) {
        var io = new IntersectionObserver(function (entries) {
          suppressed = entries.some(function (e) { return e.isIntersecting; });
          update();
        }, { rootMargin: '0px 0px -10% 0px' });
        Array.prototype.forEach.call(targets, function (t) { io.observe(t); });
      }
    }

    function locked() {
      // HubSpot-Pop-up / Menü offen: der Body wird auf overflow:hidden gesetzt
      try { return getComputedStyle(document.body).overflow === 'hidden'; } catch (e) { return false; }
    }

    function update() {
      var show = !suppressed && !locked() && window.pageYOffset > offset;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('lpk-sticky-on', show);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.setInterval(update, 800);
    update();

    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-lpk-sticky-close]')) {
        bar.classList.remove('is-visible');
        document.body.classList.remove('lpk-sticky-on');
        try { sessionStorage.setItem(key, 'closed'); } catch (err) {}
        window.setTimeout(function () { bar.remove(); }, 350);
        return;
      }
      var opener = e.target.closest('[data-lpk-sticky-open]');
      if (!opener) return;

      var mode = bar.dataset.mode;
      var value = bar.dataset.value || '';

      if (mode === 'klaviyo') {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', value]);
      } else if (mode === 'selector') {
        var el = document.querySelector(value);
        if (el) { el.click(); return; }
      } else if (mode === 'event') {
        window.dispatchEvent(new CustomEvent(value, { detail: { lp: bar.dataset.lp || '' } }));
      }

      window.dispatchEvent(new CustomEvent('lpk:voucher-open', { detail: { lp: bar.dataset.lp || '', mode: mode } }));
      if (window.dataLayer) {
        window.dataLayer.push({ event: 'lp_voucher_open', lp: bar.dataset.lp || '' });
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-lpk-sticky]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
